import type { TPlayer } from '@skillarea/game-fourinarow-phaser';

function createHiddenContainer(): globalThis.HTMLDivElement {
  const container = window.document.createElement('div');
  container.style.position = 'absolute';
  container.style.left = '-10000px';
  container.style.top = '0';
  container.style.width = '1px';
  container.style.height = '1px';
  container.style.overflow = 'hidden';
  window.document.body.appendChild(container);
  return container;
}

export async function preloadPhaserGame(gameSlug: string): Promise<void> {
  if (typeof window === 'undefined') {
    return;
  }

  const container = createHiddenContainer();

  try {
    if (gameSlug === 'tic-tac-toe') {
      const mod = await import('@skillarea/game-tictactoe-phaser');
      const Game = mod.TicTacToePhaserGame as unknown as new (args: {
        parent: globalThis.HTMLDivElement;
        localPlayer: TPlayer;
        onCellClick: (row: number, col: number) => void;
        onGameEnd: (winner: TPlayer | null, isDraw: boolean) => void;
      }) => { destroy: () => void; whenReady?: () => Promise<void> };
      const game = new Game({
        parent: container,
        localPlayer: 0,
        onCellClick: () => undefined,
        onGameEnd: () => undefined,
      });
      if (game.whenReady) await game.whenReady();
      game.destroy();
      return;
    }

    if (gameSlug === 'four-in-a-row') {
      const mod = await import('@skillarea/game-fourinarow-phaser');
      const Game = mod.FourInARowPhaserGame as unknown as new (args: {
        parent: globalThis.HTMLDivElement;
        localPlayer: TPlayer;
        onColumnClick: (col: number) => void;
        onGameEnd: (winner: TPlayer | null, isDraw: boolean) => void;
      }) => { destroy: () => void; whenReady?: () => Promise<void> };
      const game = new Game({
        parent: container,
        localPlayer: 0,
        onColumnClick: () => undefined,
        onGameEnd: () => undefined,
      });
      if (game.whenReady) await game.whenReady();
      game.destroy();
      return;
    }

    if (gameSlug === 'battleship') {
      const mod = await import('@skillarea/game-battleship-phaser');
      const Game = mod.BattleshipPhaserGame as unknown as new (args: {
        parent: globalThis.HTMLDivElement;
        onShoot?: (row: number, col: number) => void;
      }) => { destroy: () => void; whenReady?: () => Promise<void> };
      const game = new Game({
        parent: container,
        onShoot: () => undefined,
      });
      if (game.whenReady) await game.whenReady();
      game.destroy();
      return;
    }
  } finally {
    container.remove();
  }
}
